export default {
  plans: {
    list: []
  }
}

